module.exports = __webpack_public_path__ + "img/Zhambyl_obl.3d4e1325.png";